import GaugeChart from "./GaugeChart";
import LinearChart from "./LineChart";
import TemperatureChart from "./TemperatureChart";
import ContactChart from "./ContactChart";
import ConductivityChart from "./ConductivityChart";

export const ChartsJson = 
	{
		ISA: [
			{
				title: "LeakTestPressure",
				params: {
					dataKey: 'LeakTestPressure',
					component: GaugeChart
				}
			},
			{
				title: "LeakTestPressure",
				params: {
					dataKey: 'LeakTest',
					component: GaugeChart
				}
			},
			{
				title: "MainPumpPressure",
				params: {
					dataKey: 'MainPumpPressure',
					component: GaugeChart
				}
			},
			{
				title: "channelFlowCheck",
				params: {
					dataKey: 'ChannelFlowCheck',
					component: LinearChart
				}
			},
			{
				title: "Temperature",
				subTitleDataKey: 'Unit',
				params: {
					dataKey: 'Temperature',
					minValue: "TempSetPt1",
					maxValue: "MaxCycleTemp",
					lowerLimit: "MinTempRec",
					upperLimit: "MaxTempRec",
					unit: "Unit",
					component: TemperatureChart
				}
			},
			{
				title: "Contact",
				subTitleDataKey: 'SubTitle',
				params: {
					dataKey: 'Contact',
					component: ContactChart
				}
			},
			{
				title: "Conductivity",
				params: {
					dataKey: 'Conductivity',
					component:ConductivityChart
				}
			}
		]
	}